import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export interface IWorkbenchLayoutS {
  layout: any,
}

@Module({ dynamic: true, store, name: 'workbenchlayoutsser' })
class WorkbenchLayout extends VuexModule {
    public layout:any = localStorage.getItem('store') && JSON.parse(localStorage.getItem('store') as string).workbenchlayoutsser ? JSON.parse(localStorage.getItem('store') as string).workbenchlayoutsser.layout : []
    getModule: any;
    get getLayouts() {
      return this.layout;
    }
    @Mutation
    private SET_LAYOUT(layout: any) {
      this.layout = layout;
      try {
        const store = JSON.parse(localStorage.getItem('store') as string) || {};
        store.workbenchlayoutsser = { layout: layout };
        localStorage.setItem('store', JSON.stringify(store));
      } catch (e) {
        localStorage.setItem('store', JSON.stringify({ workbenchlayoutsser: { layout: layout } }));
      }
    }
    @Action
    public async setLayout(layout: any) {
      this.SET_LAYOUT(layout);
    }
}
export const WorkbenchLayoutModules = getModule(WorkbenchLayout);
